import { useAtom } from 'jotai'
import { currentStep } from '@/app/store'
import { cn } from '@/app/utils/cn'

interface StepsProps {
  visible?: boolean
  totalSteps?: number
}
export default function Steps({ visible, totalSteps = 3 }: StepsProps) {
  const [step] = useAtom(currentStep)
  return (
    <div className={visible ? 'mb-8 mt-5 flex gap-2.5' : 'hidden'}>
      {new Array(totalSteps).fill(0).map((_, i) => (
        <div className="h-[20px] w-full rounded-full bg-white02" key={i}>
          <div
            className={cn(
              'h-full w-0 rounded-full bg-primary',
              step === i && 'w-1/2',
              step > i && 'w-full',
            )}
          />
        </div>
      ))}
    </div>
  )
}
